/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_LayoutInputs */

const cs_public_site_demand_layout = /** @type {(inputs: Public_Site_Demand_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispozice`)
};

const en_public_site_demand_layout = /** @type {(inputs: Public_Site_Demand_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Public_Site_Demand_LayoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_layout = /** @type {((inputs?: Public_Site_Demand_LayoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_LayoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_layout(inputs)
	return cs_public_site_demand_layout(inputs)
});